import React from 'react'
import styles from './index.module.less'

function Star ({ data, index }) {
  const trackInfo = data.trackInfo
  return (
    <dl>
      <dt>
        <a data-spm={data.spm}
          data-mname={trackInfo.drawer}
          data-cname={trackInfo.component_title}
          data-cid={trackInfo.component_id}
          data-mid={trackInfo.drawerid}
          data-trackinfo={JSON.stringify(trackInfo)}
          href={data.videoLink}
          title={data.title}
          target='_blank'>
          <img src={data.img} alt={data.title} />
        </a>
      </dt>
      <dd>
        <a data-spm={data.spm}
          data-mname={trackInfo.drawer}
          data-cname={trackInfo.component_title}
          data-cid={trackInfo.component_id}
          data-mid={trackInfo.drawerid}
          data-trackinfo={JSON.stringify(trackInfo)}
          className={styles.star_name}
          href={data.videoLink}
          target='_blank'>{data.title}</a>
      </dd>
      {
        data.summary && <dd className={styles.hot}>{data.summary}</dd>
      }
    </dl>
  )
}
const Stars = (props) => {
  const itemList = props.component && props.component.itemList
  const trackInfo = props.component.trackInfo || {}
  return (
    <div className={`g-row ${styles.star_list}`}
      data-spm={props.component.spm}
      data-name='c_pos'
      data-mname={trackInfo.drawer}
      data-cname={trackInfo.component_title}
      data-cid={trackInfo.component_id}
      data-mid={trackInfo.drawerid}
      data-trackinfo={JSON.stringify(trackInfo)}>
      {
        itemList.map((item, index) => (
          <div key={index} className={`${styles.star_item} ${Math.floor(index / 7) === Math.floor((itemList.length - 1) / 7) ? styles.last_line : ' '} ${(index % 7 === 6) ? 'g-col m-hide' : (index % 7 > 3) ? 'g-col  s-hide' : 'g-col'}`}>
            <Star data={item} index={index} />
          </div>
        ))
      }
    </div>
  )
}
export default Stars
